export type SubscriptionStatusColor =
  | "success"
  | "failure"
  | "warning"
  | "info"
  | "gray";

/**
 * Maps a subscription status (DS or live Chargebee, any casing) to a flowbite
 * Badge color for the Subscriptions tab. Kept apart from `getStatusColor`
 * (`statusColor.ts`) on purpose: that mapper is shared with the Security tab,
 * and extending it would change the badges there. Unknown and legacy
 * non-enum statuses (e.g. `unpaid`, `past_due`) render gray.
 */
export const getSubscriptionStatusColor = (
  status?: string | null
): SubscriptionStatusColor => {
  switch ((status ?? "").toLowerCase()) {
    case "active":
      return "success";
    case "trialing":
    case "in_trial":
      return "info";
    case "cancellation_scheduled":
    case "non_renewing":
      return "warning";
    case "canceled":
    case "cancelled":
      return "failure";
    default:
      return "gray";
  }
};
